import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
export const Mechanism = () => {
  return <Section className="bg-terracotta text-white" data-id="element-124">
      <div className="max-w-3xl mx-auto text-center" data-id="element-125">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/20 mb-8" data-id="element-126">
          <ShieldCheck size={32} className="text-white" data-id="element-127" />
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-128">
          El Secreto: La Micro-Pausa de 3 Segundos
        </h2>

        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-white/90 font-light" data-id="element-129">
          <p data-id="element-130">
            La clave no es la paciencia infinita, sino la{' '}
            <strong className="font-semibold text-white" data-id="element-131">
              Micro-Pausa de 3 Segundos
            </strong>
            .
          </p>
          <p data-id="element-132">
            Este es un sistema de interrupción neurológica que bloquea la
            respuesta del grito en el centro de mando de tu cerebro.
          </p>
          <p className="text-xl md:text-2xl font-serif italic mt-8" data-id="element-133">
            "No necesitas años de terapia; necesitas un interruptor de
            emergencia que funcione en el momento exacto en que sientes que vas
            a explotar."
          </p>
        </div>
      </div>
    </Section>;
};